/*
 * What a thermal refusal means, in the reader's language: by its code where
 * the panel knows it (thermal.json `codes`), else by its HTTP status, else a
 * general sentence. The server's own English sentence is never the message;
 * a decoder's own reason, which names the file's problem, is added after it.
 */
export const KNOWN_CODES = [
  'thermal_not_radiometric', 'thermal_format_ambiguous', 'thermal_decoder_unavailable', 'thermal_decode_failed',
  'thermal_sha_mismatch', 'thermal_too_large', 'thermal_not_uploaded', 'thermal_not_decoded',
  'thermal_no_valid_pixels', 'thermal_matrix_mismatch', 'thermal_unsupported_type', 'capture_not_found',
  'capture_exists_hidden', 'derivation_not_found', 'invalid_roi', 'duplicate_label', 'invalid_range',
  'invalid_params', 'invalid_ambient', 'invalid_reference', 'invalid_format', 'forbidden',
];

export function refusalText(t, body = {}, status = null) {
  const code = body?.code;
  if (code && KNOWN_CODES.includes(code)) {
    const extra = code === 'thermal_format_ambiguous' && Array.isArray(body.candidates)
      ? body.candidates.map(k => t(`format.names.${k}`, { defaultValue: k })).join(', ')
      : (body.reason || body.needs || '');
    const text = t(`codes.${code}`);
    return extra ? `${text} (${extra})` : text;
  }
  if (status && t(`status.${status}`, { defaultValue: '' })) return t(`status.${status}`);
  return t('codes.other');
}
